<template>
  <div class="manageApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="meheader">
      <div class="headMe">
        <img :src="userData.avatar" />
        <div class="right">
          <h2>{{userData.username}}</h2>
          <p>加入时间:{{userData.createtime}}</p>
        </div>
        <div class="setTake" @click="DialogVisible = true"><em class="el-icon-setting"></em></div>
      </div>

      <ul>
        <li>
          <h3>{{(total - coupon).toFixed(2)}}</h3>
          <div>总收入</div>
        </li>
        <li @click="toPush(business.id,'arrival')">
          <h3>{{arrival}}</h3>
          <div>未到账</div>
        </li>
        <li @click="toPush(business.id,'wallet')">
          <h3>{{cash}}</h3>
          <div>已提现</div>
        </li>
        <li>
          <h3>{{cxorder}}</h3>
          <div>促销订单</div>
        </li>
        <li @click="toPush(business.id,'mallstaff')">
          <h3>{{hy}}</h3>
          <div>会员</div>
        </li>
        <li @click="toPush(business.id,'pdeliver')">
          <h3>0</h3>
          <div>配送员</div>
        </li>
      </ul>
    </div>
    <div class="nav">
      <div class="nav-item" @click="toPush(business.id,'malladdress')">
        <img src="~assets/images/nav2.png"/>
        <p>地址围栏</p>
      </div>
      <!--<div class="nav-item" @click="toPush(business.id,'sms')">
        <img src="~assets/images/nav4.png"/>
        <p>广告消息</p>
      </div>-->
      <div class="nav-item" @click="toPush(business.id,'couponlist')">
        <img src="~assets/images/nav3.png"/>
        <p>优惠劵</p>
      </div>
      <div class="nav-item" @click="toPush(business.id,'managepro')">
        <img src="~assets/images/nav1.png"/>
        <p>商家产品</p>
      </div>
      <div class="nav-item" @click="toPush(business.id,'attribute')">
        <img src="~assets/images/menu_icon3.png"/>
        <p>属性分类</p>
      </div>
      <div class="nav-item" @click="toPush(business.id,'mallapply')">
        <img src="~assets/images/bh.png"/>
        <p>补货申请</p>
      </div>
    </div>
    <div style="background:#fff;padding-bottom:10px">
      <table border="0" cellpadding="0" cellspacing="0" style="width:94%;text-align:center;line-height:32px;margin:0 auto;font-size:15px">
        <tr style="background:#ebebeb;">
          <th>年份</th>
          <th>月份</th>
          <th>订单数量</th>
          <th>促销订单</th>
          <th>总额</th>
        </tr>
        <tr v-for="(item,i) in setMallTotal" style="background:#ededed;">
          <td :rowspan="setMallTotal.length" v-if="i == 0">{{year}}年</td>
          <td>{{item.monthss}}月</td>
          <td>{{item.num}}</td>
          <td>{{item.total}}</td>
          <td>{{(item.price - item.cash_price*1).toFixed(2)}}</td>
        </tr>
      </table>
    </div>
    <div class="h2">{{business.title}}订单
      <a @click="tabOrder(1)" :class="showTab == 1 ? 'curt' :''" style="margin-left:12px">订单</a>
      <a @click="tabOrder(2)" :class="showTab == 2 ? 'curt' :''">促销订单</a>
    </div>
    <div class="pro" v-for="(item,i) in detail">
      <div class="goods" v-for="(vo,j) in item.content">
        <div class="left">
          <el-image style="width:100%;height:40px; border-radius:5px;" :src="baseUrl+vo.img" fit="cover"></el-image>
        </div>
        <div class="right">
          <p>{{vo.title}}</p>
          <div class="num">{{vo.attr != undefined && vo.attr != '' ? vo.attr+'；' : '购买数量：'}}{{vo.num}}件</div>
          <div class="price">
            <i>￥</i><b>{{vo.rate.split(".")[0]}}</b>
            <i>.{{vo.rate.split(".")[1]}}</i>
          </div>
        </div>
      </div>
      <div class="email" style="margin-top:10px">
        配送方式
        <span>{{item.type == 1 ? '自取' : '外卖'}}</span>
      </div>
      <div class="email">
        支付状态
        <span>{{item.status == 1 ? '待支付' : item.status == 2 ? '已支付' : '已发货'}}</span>
      </div>
      <div class="email">
        商品编号
        <span>{{item.number}}</span>
      </div>
      <div class="email" v-if="item.type == 1 && item.tablenum > 0">
        餐桌编号
        <span>{{item.tablenum}}号餐桌</span>
      </div>
      <div class="email" v-if="item.type == 1">
        联系人<i style="opacity:0">人</i>
        <span>{{item.username}}</span>
      </div>
      <div class="email" v-if="item.type == 1 && item.phone != '' && item.phone != null">
        联系电话
        <span>{{item.phone}}</span>
      </div>
      <div class="email" v-if="item.type == 2 && item.logistics != ''">
        物流单号 
        <span>{{item.logistics}}</span>
      </div>
      <div class="email" v-if="item.type == 2">
        配送地址 
        <span>{{item.address}}</span>
      </div>
      <div class="email" v-if="item.type == 2">
        收货人<i style="opacity:0">人</i>
        <span>{{item.name}}（{{item.phone}}）</span>
      </div>
      <div class="email" v-if="item.remark != ''">
        订单备注 
        <span>{{item.remark}}</span>
      </div>
      <div class="email" >
        优惠劵<i style="opacity:0">劵</i>
        <span>-￥{{item.coupon}}</span>
      </div>
      <div class="email" v-if="showTab == 1">
        <a @click="order_id=item.id;wlVisible=true" v-if="item.status == 2 && item.type == 2">立即发货<font class="el-icon-arrow-right"></font></a>
        支付金额<span class="curt">￥{{(item.price - item.coupon).toFixed(2)}}元</span>
      </div>
    </div>

    <div v-if="detail.length <= 0" style="height:180px;background:#fff;text-align:center;line-height:180px;font-size:14px;color:#666">暂无订单数据</div>


    <el-dialog title="设置商家配送费" :visible.sync="DialogVisible" width="92%" top="45%" center :show-close="false" :close-on-click-modal="false" custom-class="addContracts">
      <div class="timesNode" style="padding-top:40px">
        上一次价格{{business.take_price}}元 
        <input type="number" placeholder="请输入" v-model="take_price" value=""/>
        元
      </div>
      <div class="timesNode">
        外卖员提成{{business.take_draw}}% 
        <input type="number" placeholder="请输入" v-model="take_draw" value=""/>
        %
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogVisible = false;take_price='';take_draw=''">取 消</el-button>
        <el-button type="primary" @click="yesTake">确 定</el-button>
      </span>
    </el-dialog>

     <el-dialog title="物流单号" :visible.sync="wlVisible" width="92%" top="45%" center :show-close="false" :close-on-click-modal="false" custom-class="addContracts">
      <br>
      <div class="timesNode">
        物流单号
        <input type="number" placeholder="请输入" style="width:70%" v-model="logistics" value=""/>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="wlVisible = false;order_id=''">取 消</el-button>
        <el-button type="primary" @click="deliver">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        wlVisible:false,
        DialogVisible:false,
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        detail:[],
        business:[],
        userData:[],
        remark:'',
        total:0,
        prototal:0,
        bg:require( '../../assets/images/lock_bg.png'),
        coupon:0,
        cash:0,
        hy:0,
        dzwl:0,
        setMallTotal:[],
        year:2024,
        take_price:'',
        take_draw:'',
        cxorder:0,
        arrival:0,
        showTab:1,

        logistics:'',
        order_id:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;

      this.year = new Date().getFullYear();
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getTotal:function(id){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/product/yearMalltotal',
          data:{
            mall_id:id,
          },
          dataType:'json',
          success:function(data){
            that.setMallTotal = data.data
          }
        })
      },
      yesTake:function(){
        var that = this;
        if(that.take_price == ''){
          that.$alert('请输入配送费','提示')
          return false;
        }
        if(that.take_draw == ''){
          that.$alert('请输入配送配送员提成','提示')
          return false;
        }
        var id = that.business.id;
        $.ajax({
          type:'post',
          url:that.$host+'home/product/setBusiness',
          data:{
            mall_id:id,
            take_price:that.take_price,
            take_draw:that.take_draw,
          },
          dataType:'json',
          success:function(data){
            that.getDetail();
            that.take_price = '';
            that.take_draw = '';
            that.DialogVisible = false;
          }
        })
      },
      tabOrder:function(inx){
        this.showTab = inx;
        this.getDetail();
      },
      getDetail:function(){
        var that = this;
        that.fullscreenLoading = true
        var phone = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/product/business',
          params:{
            phone:phone,
            pid:(that.showTab == 1 ? 0 : 1)
          }
        }).then(function(response){
          var res = response.data.data;
          that.detail = res.rs;
          that.total = res.total;
          that.prototal = res.prototal;
          that.dzwl = res.dzwl;
          that.business = res.business;
          that.coupon = res.coupon;
          that.cash = res.cash
          that.hy = res.hy;
          that.cxorder = res.cxorder;
          that.arrival = res.arrival;
          that.getTotal(res.business.id)
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      deliver:function(){
        var that = this;
        if(that.logistics == ''){
          that.$alert('请输入物流单号','提示')
          return false;
        }
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/deliver',
          params:{
            id:that.order_id,
            logistics:that.logistics
          }
        }).then(function(response){
          that.getDetail();
          that.fullscreenLoading = false;
          that.wlVisible = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .manageApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .manageApp .meheader{
    background: linear-gradient(90deg, #61BEFF, #4F7CFF);
  }
  .manageApp .headMe{
    width:92%;
    margin:0 auto;
    padding:15px 0;
    position:relative;
  }
  .manageApp .headMe:after,.manageApp ul:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .manageApp .headMe img{
    width:60px;
    border-radius:100%;
    float:left;
  }
  .manageApp .headMe .right{
    float:left;
    width:75%;
    margin-left:3%;
  }
  .manageApp .headMe .right h2{
    font-size:18px;
    padding:7px 0 5px 0;
    color:#fff
  }
  .manageApp .headMe .right h2 input{
    font-weight:normal;
    font-size:12px;
    color:#FF6600;
    border:none;
    width:65px;
    background:none;
    outline:none;
  }
  .manageApp .headMe .right p{
    font-size:15px;
    color:#555;
    color:#fff
  }
  .manageApp .headMe .setTake{
    color:#fff;
    font-size:22px;
    right:0;
    top:25px;
    position:absolute;
  }
  .manageApp ul{
    clear:both;
    padding:0px 0 12px 0;
    width:100%
  }
  .manageApp ul li{
    float:left;
    width:16.6%;
    position:relative;
  }
  .manageApp ul li:after{
    position:absolute;
    content:'';
    width:1px;
    height:30px;
    background:#61BEFF;
    right:0;
    top:50%;
    transform: translateY(-50%);
  }
  .manageApp ul li:last-child:after{
    background:#4F7CFF;
  }
  .manageApp ul li h3{
    text-align:center;
    font-size:15px;
    color:#fff
  }
  .manageApp ul li div{
    text-align:center;
    font-size:11px;
    color:#666;
    padding-top:3px;
    color:#fff
  }

  .manageApp .nav{
    background:#fff;
    padding-bottom:12px
  }
  .manageApp .nav:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .manageApp .nav .nav-item{
    float:left;
    width:20%;
    margin-top:12px
  }
  .manageApp .nav .nav-item img{
    width:40px;
    display:block;
    margin:0 auto
  }
  .manageApp .nav .nav-item p{
    width:100%;
    text-align:center;
    font-size:14px;
    color:#333;
    padding-top:8px;
    font-weight:bold;
  }
  .manageApp .h2{
    padding:10px 0 0px 0;
    color:#000;
    font-size: 16px;
    background:#fff;
    position: relative;
    padding-left:6%;
    font-weight:bold;
    margin-top:10px
  }
  .manageApp .h2 a{
    font-size:13px;
    font-weight:normal;
    background:#F6F8FB;
    border-radius:2px;
    color:#666666;
    font-size:12px;
    margin-right:8px;
    padding:5px 8px
  }
  .manageApp .h2 a.curt{
    color:#00A2FF
  }
  .manageApp .h2:after {
    content: '';
    width: 3px;
    height: 12px;
    background: #141EF1;
    position: absolute;
    left: 4%;
    top: 15px;
    border-radius: 3px;
  }

  .manageApp .pro{
    background:#fff;
    display:block;
    width:100%;
    margin:0 auto 1px auto;
    padding-top:10px
  }
  .manageApp .pro .goods:after,.manageApp .email:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }

  .manageApp .goods{
    background:#ebebeb;
    width:92%;
    margin:0 auto;
  }
  .manageApp .goods .left{
    float:left;
    width:16%;
    border-radius:5px;
    margin:2% 2% 1% 2%;
  }
  .manageApp .goods .right{
    float:left;
    margin-top:2%;
    width:76%;
    position: relative;
    min-height:40px;
  }
  .manageApp .goods .right p{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#000;
    width:78%
  }
  .manageApp .goods .right .num{
    font-size: 12px;
    color: #999999;
    padding-top:3px;
  }
  .manageApp .goods .right .price{
    color:#f00;
    font-size:15px;
    position: absolute;
    top:0;
    right:0;
    text-align:right
  }
  .manageApp .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }
  .manageApp .goods .right .price b{
    color: #f00;
    font-size:18px;
    font-weight:600;
  }

  .manageApp .goods .right .price i{
    color: #f00;
    font-size:13px;
    font-style:normal
  }
  
  .manageApp .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }
  .manageApp .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }

  .manageApp .email{
    background:#fff;
    font-size:14px;
    color:#666;
    display:block;
    padding:0 0 10px 4%;
    margin:0 auto;
  }
  .manageApp .email span{
    color:#000;
    font-size: 14px;
    font-weight:normal;
    margin-left:4%
  }
  .manageApp .email span.curt{
    color:#f00;
    font-size:15px;
  }
  .manageApp .email a{
    float:right;
    color:rgba(0,74,224,.7);
    margin-right:4%;
    font-size:15px;
    padding-left:10px;
    font-weight:bold
  }


  .manageApp .addContracts{
    border-radius: 8px;
  }
  .manageApp .addContracts .el-dialog__header{
    border-bottom:solid 1px #EAECED;
    padding:15px 15px 14px 10px
  }
  .manageApp .addContracts .el-dialog__header .el-dialog__title{
    font-weight: bold;
    color:#000
  }
  .manageApp .addContracts .el-dialog__body{
    padding:10px 20px 20px 20px
  }
  .manageApp .addContracts button{
    width:45%;
    height:45px;
    border-radius: 8px;
    background: #F2F4F7;
    border:none;
    color:#000;
    font-size:15px
  }
  .manageApp .addContracts button:last-child{
    background: #0059D6;
    color:#fff
  }
  .manageApp .addContracts .close{
    position:absolute;
    bottom:-60px;
    width:35px;
    left:50%;
    transform: translateX(-50%);
  }
  .manageApp .addContracts .timesNode{
    height:45px;
  }
  .manageApp .addContracts .timesNode .el-select{
    width:36%
  }
  .manageApp .addContracts .timesNode input{
    width:36%;
    background: #F2F4F7;
    border:none;
    height: 32px;
    border-radius: 6px;
    padding:0 0 0 8px;
    outline:none;
    margin-left:8px
  }
</style>